import {webRequest, webNoTokenRequest} from '../api'

// 房客拍表紀錄
// {
//     "contractSeq" : "CT210618000005",
//     "type" : ELECTRICITY, //WATER, ELECTRICITY, GAS
// }
export function getMeterRecord(params) {
    return webRequest({
        url:'/v2/oauth/order/manage/utility/meter/record',
        method:'get',
        params: params,
    })
}




// WEBPACK FOOTER //
// ./src/apis/landlord/meterRecord.js